<template>
    <div class="container-fluid mt-5">
        <h1 v-if="advertisement != null && advertisement.name != null">{{ advertisement.name }}</h1>

        <h2><a :href="`sms:${advertisement.phone}`" target="_blank">{{ advertisement.phone }}</a></h2>

        <div class="row">
            <div class="col-md-6">
                <div v-for="picture in advertisement.pictures" :key="picture.id">
                    <img class="img-fluid m-2" :src="`${cdn_url}/orig/${picture.name.replace('.jpg', '.webp')}`" :alt="`${advertisement.name} Escort Girl`">
                </div>
            </div>

            <div class="col-md-6">
                Phone: {{ advertisement.phone }}<br>
                Age: {{ advertisement.age }}<br>
                Height: {{ advertisement.height }} cm<br>
                Weight: {{ advertisement.weight }} kg<br>
                Breast: {{ advertisement.breast }}<br>
                Eyes: {{ advertisement.eyes }}<br>
                Hair: {{ advertisement.hair }}<br>
                Languages: {{ advertisement.conversation }}<br>
                Smoking: {{ advertisement.smoking }}
                <h4>Rates:</h4>
                Incall: {{ advertisement.inCall }}<br>
                Outcall: {{ advertisement.outCall }}<br>
                <div class="mt-3" v-html="advertisement.description">                    
                </div>

                <h4>Book now in SMS</h4>
                <p>
                    <a :href="`sms:${advertisement.phone}`" target="_blank">{{ advertisement.phone }}</a>
                </p>

                <p class="alert-danger">
                Please write me where and when you want to meet me!
                </p>
                <p>
                    Date of appointment<br>
                    Hotel, apartment name<br>
                    Exact address:<br>
                    district, street, house number<br>
                    Room number<br>
                    Telephone number
                </p>
                <p>
                    Thank you
                </p>

                <b-button variant="danger" v-b-modal.modal-booking>Booking</b-button>                
            </div>


            <b-modal
            id="modal-booking"
            ref="modal"
            title="Booking"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk"
            >
                <p class="alert-danger font-weight-bold text-center">
                    Your booking request goes straight to the girl you'd like to book.
                    She will contact you as soon as possible.
                </p>
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                        label="Your name"
                        label-for="name-input"
                        invalid-feedback="Name required"
                >
                    <b-form-input
                            id="name-input"
                            v-model="model.name"
                            :state="nameState"
                            required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                        label="Your e-mail"
                        label-for="name-input"
                        invalid-feedback="E-mail is required"
                >
                    <b-form-input
                            id="email-input"
                            v-model="model.email"
                            :state="emailState"
                            type="email"
                            required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                        label="Your phone"
                        label-for="name-input"
                        invalid-feedback="Phone is required"
                >
                    <b-form-input
                            id="phone-input"
                            v-model="model.phone"
                            :state="phoneState"
                            type="text"
                            required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                        label="Message"
                        label-for="name-input"
                        invalid-feedback="Message required"
                >
                    <b-form-textarea
                            id="description-input"
                            v-model="model.message"
                            :state="messageState"
                            required
                    ></b-form-textarea>
                </b-form-group>
            </form>
            </b-modal>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Show",
        metaInfo() {
          return {
              title: this.advertisement.name,
              meta: [
                  { name: 'description', content: this.advertisement.metaDescription },
                  {name: 'twitter:card', content: 'summary'},
                  {name: 'twitter:title', content: this.advertisement.name},
                  {name: 'twitter:description', content: this.advertisement.metaDescription},
                  {name: 'twitter:image', content: `${process.env.VUE_APP_CDN_URL}/orig/${this.advertisement.pictures[0].name.replace('.jpg', '.webp')}`},
                  // Facebook OpenGraph
                  {property: 'og:title', content: this.advertisement.name},
                  {property: 'og:site_name', content: this.advertisement.name},
                  {property: 'og:type', content: 'website'},
                  {property: 'og:image', content:  `${process.env.VUE_APP_CDN_URL}/orig/${this.advertisement.pictures[0].name.replace('.jpg', '.webp')}`},
                  {property: 'og:description', content: this.advertisement.metaDescription}
              ]
          }
        },
        data() {
            return {
                cdn_url: process.env.VUE_APP_CDN_URL,
                advertisement: '',
                nameState: null,
                emailState: null,
                messageState: null,
                phoneState: null,
                model: {
                    name: '',
                    email:  '',
                    message: '',
                    phone: '',
                }
            }
        },
        created() {
            window.scrollTo(0,0);
            this.fetchData()
        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/advertisements/${this.$route.params.id}`)
                .then((response) => {
                    this.advertisement = response.data
                })
            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.nameState = valid
                this.emailState = valid
                this.messageState = valid
                this.phoneState = valid
                return valid
            },

            resetModal() {
                this.model.name = '';
                this.model.email = '';
                this.model.message = '';
                this.model.phone = '';
                this.model.place = '';
                this.model.room = '';
                this.model.date = '';
                this.model.from = '';
                this.model.to = '';
                this.nameState = null;
                this.emailState = null;
                this.messageState = null;
                this.phoneState = null;
            },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()
                // Trigger submit handler
                this.handleSubmit()
            },
            handleSubmit() {
                if (!this.checkFormValidity()) {
                    return
                }

                this.$http.post(`${process.env.VUE_APP_API_URL}/advertisements/${this.$route.params.id}/booking`, this.model)
                    .then(() => {
                        this.$bvModal.msgBoxOk("Booking request sent!");
                        this.$gtag.event('booking', {
                          'event_category': 'action',
                          'event_label': 'send',
                          'value': this.$route.params.id
                        })
                    }).catch(message => {
                    this.$bvModal.msgBoxOk(message);
                    this.$gtag.event('booking', {
                        'event_category': 'action',
                        'event_label': 'error',
                        'value': this.$route.params.id
                    })
                })

                // Hide the modal manually
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-booking')
                })

            },

        }
    }
</script>
